import { useEffect, useState } from 'react';
import { supabase } from '../../../lib/supabase';

interface UseOrgFeaturesReturn {
  pickupHandinEnabled: boolean;
}

// Read-only per-org feature flag lookup. The pickup/hand-in confirmation flow is
// opt-in per organization (managed by super admins in AdminPage), so every planning
// surface needs to know whether it's on before changing availability/UI behavior.
export function useOrgFeatures(orgId: string | null): UseOrgFeaturesReturn {
  const [pickupHandinEnabled, setPickupHandinEnabled] = useState(false);

  useEffect(() => {
    if (!orgId) {
      setPickupHandinEnabled(false);
      return;
    }
    let cancelled = false;
    supabase
      .from('organizations')
      .select('pickup_handin_enabled')
      .eq('id', orgId)
      .maybeSingle()
      .then(({ data }) => {
        if (!cancelled) setPickupHandinEnabled(data?.pickup_handin_enabled ?? false);
      });
    return () => {
      cancelled = true;
    };
  }, [orgId]);

  return { pickupHandinEnabled };
}
